import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import Cookies from 'js-cookie';
import React from 'react';
import { useContext } from 'react';
import { AddOrRemoveCookies } from 'utils/AddOrRemoveCookies';

const useUserLoginControl = () => {
  const GlobalConstants = useContext(GlobalContext);
  const navigate = GlobalConstants.navigate;
  React.useEffect(() => {
    if (Cookies.get('user') !== undefined) {
      navigate({
        pathname: '/main',
      });
    } else {
      AddOrRemoveCookies('remove', 'user', false);
      AddOrRemoveCookies('remove', 'userImage', false);
    }
  });
};

export default useUserLoginControl;
